import { render } from "./G01ItemCarousel.vue?vue&type=template&id=0db153cd&scoped=true&ts=true"
import script from "./G01ItemCarousel.vue?vue&type=script&lang=ts"
export * from "./G01ItemCarousel.vue?vue&type=script&lang=ts"

import "./G01ItemCarousel.vue?vue&type=style&index=0&id=0db153cd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db153cd"]])

export default __exports__